module.exports = __webpack_public_path__ + "img/fr.4781c8d6.svg";